export default {
  title: 'Mes vidéos sous-titrées',
  loadingText: 'Chargement des sous-titres...',
  createButton: 'Créer',
  emptyState: {
    title: 'Démarrez le sous-titrage de vos vidéos',
    description: 'Cette fonctionnalité vous permet de générer des sous-titres mais aussi de générer une transcription de votre vidéo. Cliquez sur "Commencer" pour lancer le traitement. Attention, la génération peut prendre plusieurs minutes.',
    buttonText: 'Commencer'
  },
  card: {
    created: 'Créé le',
    downloadLanguage: 'Télécharger ({language})',
    view: 'Voir la vidéo'
  },
  editor: {
    title: 'Éditeur de sous-titres',
    undo: 'Annuler',
    redo: 'Rétablir',
    saved: 'Enregistré',
    saving: 'Enregistrement...',
    unsaved: 'Modifications non enregistrées',
    saveTooltip: 'Enregistrer les modifications (Ctrl+S)'
  },
  download: {
    title: 'Télécharger les sous-titres',
    language: 'Langue : {language}',
    format: 'Format de téléchargement',
    selectFormat: 'Sélectionner le format',
    selectSubtitles: 'Sélectionner les sous-titres à télécharger',
    advancedOptions: 'Options avancées',
    includeMetadata: 'Inclure les métadonnées',
    zipMultiple: 'Télécharger en archive ZIP',
    useSlugFilename: 'Utiliser les noms techniques pour les fichiers',
    preview: 'Aperçu',
    downloadButton: 'Télécharger'
  },
  upload: {
    uploading: 'Téléchargement...',
    started: 'Téléchargement commencé',
    plannedSubtitles: 'Sous-titres à générer',
    status: {
      preparing: 'Préparation du téléchargement...',
      uploading: 'Téléchargement du fichier...',
      processing: 'Traitement de la vidéo...'
    },
    modal: {
      title: 'Télécharger une vidéo',
      configure: 'Configurer les sous-titres',
      dragDrop: 'Glissez-déposez votre vidéo ici',
      dropHere: 'Déposez votre fichier ici',
      or: 'ou',
      browse: 'Parcourir les fichiers',
      fromLibrary: 'Choisir depuis la bibliothèque',
      uploadNew: 'Télécharger une nouvelle vidéo',
      uploadNewDescription: 'Glissez-déposez ou parcourez pour télécharger un nouveau fichier vidéo',
      fromLibraryDescription: 'Sélectionnez une vidéo existante depuis votre bibliothèque',
      chooseMethod: 'Comment souhaitez-vous ajouter votre vidéo ?',
      chooseMethodDescription: 'Choisissez de télécharger une nouvelle vidéo ou de sélectionner depuis votre bibliothèque',
      tryDifferentFilter: 'Essayez un filtre différent ou un autre terme de recherche',
      supportedFormats: 'Formats supportés : MP4, AVI, MOV, MKV, WebM',
      libraryTitle: 'Bibliothèque de vidéos',
      searchVideos: 'Rechercher des vidéos...',
      filterAll: 'Toutes',
      filterNoSubtitles: 'Sans sous-titres',
      filterRecent: 'Récentes',
      noSubtitles: 'Aucun sous-titre',
      noVideosFound: 'Aucune vidéo trouvée',
      select: 'Sélectionner',
      existingVideo: 'Vidéo existante',
      existingSubtitles: 'Cette vidéo possède déjà les sous-titres suivants :',
      allowRegeneration: 'Autoriser la régénération des sous-titres existants',
      selectLanguages: 'Sélectionnez les langues de sous-titres à générer',
      popular: 'Populaire',
      presetPopular: 'Langues populaires',
      presetEurope: 'Langues européennes',
      presetAll: 'Toutes les langues',
      advancedOptions: 'Options avancées',
      audioDescription: 'Audio-description',
      simplified: 'Simplifié (Facile à lire)',
      summary: '{count} langue(s) sélectionnée(s)',
      additionalSubtitles: 'Supplémentaire : {types}',
      startUpload: 'Démarrer le téléchargement',
      errorNotVideo: 'Veuillez sélectionner un fichier vidéo',
      errorTooLarge: 'Le fichier est trop volumineux (max 2 Go)'
    }
  },
  delete: {
    title: 'Supprimer la vidéo',
    message: 'Êtes-vous sûr de vouloir supprimer "{video}" et tous ses sous-titres ? Cette action est irréversible.'
  }
}
